import { render } from "./LayoutTest.vue?vue&type=template&id=09cd6f46"
import script from "./LayoutTest.vue?vue&type=script&lang=ts"
export * from "./LayoutTest.vue?vue&type=script&lang=ts"

import "./LayoutTest.vue?vue&type=style&index=0&id=09cd6f46&lang=scss"
script.render = render

export default script